import React, { useState, useEffect } from 'react';
import { 
    Box, 
    Flex,
    Text,
    Grid,
    GridItem,
    Link,
    Spacer
 } from '@chakra-ui/react';
 import Card from './Card';
 import { Event } from './Card';

const InterestEvents = ({similarEvents}: {similarEvents: Event[]}) => {
    const [sliceEnd, setSliceEnd] = useState(3);

    useEffect(() => {
        if (window.innerWidth > 768) {
            setSliceEnd(6);
        }
    }, []);

    return(
        <Box>
            <Text as='b' fontSize='26px'>
                Вам может быть интересно
            </Text>
            <Grid 
                mt='20px'
                gap='20px' 
                templateColumns={{
                    base: "1fr", 
                    lg: "repeat(2, 1fr)", 
                    xl: "repeat(3, 1fr)"
                }}
            >
                {similarEvents?.slice(0, sliceEnd).map((event: any) => (
                    <GridItem>
                        <Card event={event}/>
                    </GridItem>
                ))}
            </Grid>
        </Box>
    );
}

export default InterestEvents;